import { PaymentGateway } from '../../../../../services/exports/Constants';

export default {
  title: 'Napsauta alla olevaa painiketta tarkistaaksesi ja vahvistaaksesi maksutietosi.',
  payment_gateways: {
    [PaymentGateway.Stripe]: {
      description:
        'Teemme yhteistyötä Stripen kanssa maksujen käsittelemiseksi. Stripe on turvallisin maksualusta, jota maailman suurimmat yritykset käyttävät.',
      form: {
        terms_acceptance: {
          label:
            'Jatkamalla hyväksyt <FoodAmigosTerms>palvelusopimuksemme</FoodAmigosTerms> ja <StripeTerms>Stripen yhdistetyn tilin sopimuksen.</StripeTerms>',
        },
      },
      labels: {
        stripe_requirements:
          'Stripe on merkinnyt osan asiakastiedoista puuttuviksi tai virheellisiksi. Korjaa seuraavat virheet napsauttamalla "Avaa Stripe-profiili" -painiketta:',
        errors: 'Virheet',
        awaiting_verification: 'Stripe-tiliäsi vahvistetaan',
        awaiting_verification_description:
          'Odotamme, että Stripe saa yrityksesi vahvistuksen valmiiksi. Voit sillä välin tarkastella profiiliasi.',
      },
    },
    [PaymentGateway.Adyen]: {
      description:
        'Teemme yhteistyötä Adyenin kanssa maksujen käsittelemiseksi. Adyen on yksi turvallisimmista maksualustoista, jota maailman suurimmat yritykset käyttävät.',
    },
  },
  labels: {
    verified: '{{paymentGateway}}-tilisi on vahvistettu',
    verified_description:
      'Vahvistus on valmis palvelulle {{paymentGateway}}. Voit silti hallita profiiliasi tarvittaessa.',
  },
  buttons: {
    proceed: 'Vahvista maksutietoni',
    copy_link: 'Kopioi linkki',
  },
  toasts: {
    something_went_wrong: 'Jokin meni pieleen, ota yhteyttä tekniseen tukeen',
  },
};
